var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStockzoneIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3664_1989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4057 41.5668H7V48H13.4057V41.5668Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4057 47.3162H7V48H13.4057V47.3162Z",
    fill: "#28345A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 41.5668H13.5944V48H20.0001V41.5668Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 47.3162H13.5944V48H20.0001V47.3162Z",
    fill: "#28345A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4056 46.0999V41.5668H8.89185L13.4056 46.0999Z",
    fill: "#EFEFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9999 46.0041V41.5668H15.5815L19.9999 46.0041Z",
    fill: "#EFEFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8836 41.5668H9.52173V43.5315H10.8836V41.5668Z",
    fill: "#027BC7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.478 41.5668H16.1161V43.5315H17.478V41.5668Z",
    fill: "#027BC7"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 0.999999C57 0.447714 57.4477 0 58 0H61C61.5523 0 62 0.447715 62 1V61C62 61.5523 61.5523 62 61 62H58C57.4477 62 57 61.5523 57 61V0.999999Z",
    fill: "#CCE5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.999999C0 0.447714 0.447715 0 1 0H4C4.55228 0 5 0.447715 5 1V61C5 61.5523 4.55228 62 4 62H1C0.447715 62 0 61.5523 0 61V0.999999Z",
    fill: "#CCE5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57 48H5V53H6.76271V50.5H55.2373V53H57V48Z",
    fill: "#027BC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26H5V31H6.76271V28.5H55.2373V31H57V26Z",
    fill: "#027BC7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8889 15.5455C45.8889 23.5787 38.6667 39.3333 31.4444 41C24.7778 39.3333 17 23.5787 17 15.5455C17 7.51222 23.467 1 31.4444 1C39.4219 1 45.8889 7.51222 45.8889 15.5455Z",
    fill: "#027BC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8889 15.5459C44.8889 8.05837 38.8631 2 31.4444 2C24.0258 2.00006 18 8.0584 18 15.5459C18.0002 19.3249 19.8603 25.1003 22.6026 30.1855C23.9648 32.7117 25.5175 35.0163 27.1153 36.7773C28.6425 38.4605 30.1294 39.5558 31.4532 39.9639C32.9094 39.5552 34.4639 38.4523 36.0128 36.7715C37.6305 35.016 39.1639 32.7173 40.4904 30.1943C43.1578 25.1209 44.8887 19.3391 44.8889 15.5459ZM45.884 15.9277C45.6635 24.0678 38.5538 39.3594 31.4444 41C24.882 39.3593 17.2431 24.0677 17.0059 15.9277L17 15.5459C17 7.5127 23.467 1.00006 31.4444 1C39.422 1 45.8889 7.51266 45.8889 15.5459L45.884 15.9277Z",
    fill: "#CCE5FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2222 14.3333C39.2222 18.6289 35.74 22.1111 31.4444 22.1111C27.1489 22.1111 23.6667 18.6289 23.6667 14.3333C23.6667 10.0378 27.1489 6.55554 31.4444 6.55554C35.74 6.55554 39.2222 10.0378 39.2222 14.3333Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2222 14.3328C38.222 10.5898 35.1871 7.55554 31.444 7.55554C27.7011 7.55577 24.6669 10.5899 24.6667 14.3328C24.6667 18.0759 27.7009 21.1109 31.444 21.1111V22.1111L31.0445 22.1013C26.9348 21.8932 23.6667 18.4943 23.6667 14.3328C23.6669 10.0377 27.1488 6.55578 31.444 6.55554C35.7393 6.55554 39.222 10.0375 39.2222 14.3328L39.2125 14.7332C39.0043 18.8429 35.6053 22.1111 31.444 22.1111V21.1111C35.1872 21.1111 38.2222 18.0761 38.2222 14.3328Z",
    fill: "#CCE5FF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_3664_1989)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4057 19.5668H48V26H54.4057V19.5668Z",
    fill: "#CCE5FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4057 25.3162H48V26H54.4057V25.3162Z",
    fill: "#28345A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.4056 24.0999V19.5668H49.8918L54.4056 24.0999Z",
    fill: "#EFEFFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8836 19.5668H50.5217V21.5315H51.8836V19.5668Z",
    fill: "#027BC7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3664_1989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(7 35)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_3664_1989"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(48 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockzoneIcon);
export default __webpack_public_path__ + "static/media/stockzoneIcon.971f2693dee2eb84fb7b43ee37580a7a.svg";
export { ForwardRef as ReactComponent };